import { ClickAwayListener, Menu, Stack } from "@mui/material";
import React, { useState } from "react";
import { HyroIconButton } from "@hyro-components";
import { ICON_BUTTON_SIZES, ICON_BUTTON_VARIANTS, ICON_COLOR_MODES } from "@hyro-components/hyro-icon-button/HyroIconButton.consts";
import MoreVertIcon from "src/icons/MoreVertIcon";

const HyroThreeDotMenu = ({ menuItems, testId, onMenuOpen, onMenuClose, sx, disablePortal = false }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const handleMenuClick = (e) => {
    e.stopPropagation();
    onMenuOpen?.();
    setAnchorEl(e.currentTarget);
  };

  const handleMenuClose = (e) => {
    e.stopPropagation();
    setAnchorEl(null);
    onMenuClose?.();
  };
  return (
    <>
      <HyroIconButton
        data-testid={`${testId}-three-dot-menu`}
        aria-controls="simple-menu"
        aria-haspopup="true"
        onClick={handleMenuClick}
        variant={ICON_BUTTON_VARIANTS.CLEAR}
        size={ICON_BUTTON_SIZES.LARGE}
        active={Boolean(anchorEl)}
        iconColorMode={ICON_COLOR_MODES.FILL}
        sx={sx}
        onMouseDown={(e) => e.preventDefault()}
      >
        <MoreVertIcon />
      </HyroIconButton>
      <ClickAwayListener onClickAway={handleMenuClose}>
        <Menu
          disablePortal={disablePortal}
          id="simple-menu"
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleMenuClose}
          onClick={handleMenuClose}
          sx={{ mt: .5, zIndex: 1600 }}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          PaperProps={{
            style: {
              maxHeight: "300px"
            }
          }}
        >
          <Stack gap={1}>
            {menuItems}
          </Stack>
        </Menu>
      </ClickAwayListener>
    </>
  );
};

export default HyroThreeDotMenu;
